import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;

    h2 {
      margin: 0;
    }

    div {
      display: flex;
      flex-direction: column;
    }
    input {
      width: 100%;
      padding: 5px 10px;
      border-radius: 5px;
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }
`;

export const TitleInputContainer = styled.div`
  display: flex;
`;

export const TitleInput = styled.input`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  border: none;
  font-size: 24px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  input {
    border-radius: 5px;
    padding: 5px 8px;
  }
`;

export const ModalContainer = styled.div`
  h2 {
    margin: 0;
  }
`;

export const AddModuloModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;

  input {
    border-radius: 5px;
    padding: 4px 8px;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 20px;
`;

export const NumberInput = styled.input`
  padding: 5px 2px;
  border-radius: 5px;
  max-width: 50px;
`;

export const ModuloHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  gap: 2rem;

  div {
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    justify-content: center;
    gap: 14px;

    button {
      background-color: transparent;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
  }
`;

export const Bottom = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
`;
